export const environment = {
  production: true,
  apiBase: 'https://api.uat.vbmc.travelex.cloud/api/v1/admin/',
  poolData: {
    UserPoolId: 'ap-southeast-2_S95zqYkpg',
    ClientId: '69pqvp72nl8bras04pgbjaasi3'
  },
};
